import { h } from 'preact';
import Section from 'components/bolt/section/section';
import s from 'components/bolt/iframe/iframe.sss';
import HTML from 'components/core/html/html.js';
import { joinClasses, accessNested } from 'utils/utils';

export default class Iframe extends Section {
	constructor(props) {
		super(props);

		this.state = {
			loaded: false
		};

		this.handleLoaded = this.handleLoaded.bind(this);
	}

	handleLoaded() {
		this.setState({ loaded: true });
	}

	getIframeStyle(size = {}, dedicatedPage) {
		if (dedicatedPage || typeof window === 'undefined') {
			return {};
		}

		let height = size.mobile.height || 375;
		let width = size.mobile.width || window.innerWidth;
		let maxWidth = 1200;

		if (window.innerWidth >= 1600) {
			height = size.largeDesktop.height || 920;
			width = size.largeDesktop.width || window.innerWidth;
			if (size.largeDesktop.width > 1200) {
				maxWidth = 'none';
			}
		} else if (window.innerWidth >= 1280) {
			height = size.desktop.height || 768;
			width = size.desktop.width || window.innerWidth;
			if (size.desktop.width > 1200) {
				maxWidth = 'none';
			}
		} else if (window.innerWidth >= 1024) {
			height = size.smallDesktop.height || 600;
			width = size.smallDesktop.width || window.innerWidth;
		} else if (window.innerHeight >= 768) {
			height = size.tablet.height || 600;
			width = size.tablet.width || window.innerWidth;
		}

		return {
			height: height + 'px',
			width: width + 'px',
			maxWidth
		};
	}

	renderHeading(heading, fontStyles) {
		return (
			<div class={s.heading}>
				<HTML
					class={'h3'}
					markdown
					content={heading}
				/>
			</div>
		);
	}

	renderDescription(description, fontStyles) {
		return (
			<div class={s.description}>
				<HTML
					class={'xlarge'}
					markdown
					content={description}
				/>
			</div>
		);
	}

	render({ data, store, id, appData, client }, { loaded }) {
		const footer = accessNested(store, 'appData.footer.defaultFooter', {});
		const dedicatedPage = data && data.url;
		const staticInlineFooter = footer.position === 'static' && footer.inline && dedicatedPage;
		const pageData = data || accessNested(appData, ['pages', id, 'data'], {});
		const { title, description } = pageData;
		const fontStyles = accessNested(appData, 'styling.fontVariables') || {};


		const style = this.getIframeStyle(pageData.size, dedicatedPage);

		return (
			<div
				class={joinClasses(s.wrapper, staticInlineFooter && s.fullHeight, dedicatedPage ? s.dedicatedPage : s.section)}
				data-section={id}
			>
				{this.renderBgContent()}
				{title && this.renderHeading(title, fontStyles)}
				{description && this.renderDescription(description, fontStyles)}
				<div class={joinClasses(s.loader, loaded && s.hide)}>
					<div class={s.spinner} />
				</div>
				<iframe
					style={style}
					ref={ref => this.iframe = ref}
					src={pageData.url}
					onLoad={this.handleLoaded}
					allowFullscreen={pageData.allowFullscreen}
				/>
				{this.renderOverlayedContent()}
			</div>
		);
	}
}
